import React, {useState} from "react";
import GalleryPopup from "../GalleryPopup";

const ImageElements = ({showAll, images, setToggleFullscreen}) => {
    let result =  showAll ? images : images.slice(0,3)
    return result.map(img => {
        return (
            <a href="#showInFullscreen" onClick={()=>setToggleFullscreen(true)}>
                <img src={img} key={img} alt="Anmärkningsbild"/>
            </a>
        )
    })
}

export default function RowImages({images}) {
    const [showAll, setShowAll] = useState(false);
    const [toggleFullscreen, setToggleFullscreen] = useState(false);

    return images.length !== 0 ? <li>
        <div className="section-title">
            <div>Anmärkningsbilder</div>
            {images.length > 3 &&
                <a onClick={() => setShowAll(!showAll)}>{showAll ? 'Se färre bilder' : 'Se alla bilder'}</a>}
        </div>
        <div className="begtest-image-container">
            <ImageElements showAll={showAll} images={images} setToggleFullscreen={setToggleFullscreen} />
            { toggleFullscreen && <GalleryPopup mediaArray={images} setToggleFullscreen={setToggleFullscreen} /> }
        </div>
    </li>: <></>;
}